export enum AppRoutes {
	Home = '/',
	Landing = 'https://www.haggles.ai/',
	About = '/us/about',
	User = '/user',
	ManageStore = '/user/manage/store',
	UserDashboard = '/user/dashboard',
	UserHaggleEvents = '/user/dashboard/haggle-events',
	UserUsers = '/user/dashboard/users',
	UserProducts = '/user/dashboard/products',
	UserReports = '/user/dashboard/reports',
	HowToVideos = '/user/dashboard/how-to-videos',
	SignIn = '/auth/sign-in',
	ConsumerDashboard = '/customer/profile',
	AdminMerchants = '/user/merchants',
	AdminHaggleEvents = '/user/haggles',
	AdminUsers = '/user/users',
	AdminProducts = '/user/products',
	AdminReports = '/user/reports',
	ShopifyOAuth = '/auth/shopify-oauth',
	InvitedUsers = '/user/invited',
	AdminConfigure = '/user/configure-app',
	HaggleInvitedUsers = '/user/dashboard/haggle-invited',
	Orders = '/user/dashboard/orders',
	AdminShopifySubscriptionDiscounts = '/user/shopify-subscription-discounts',
}
